
export enum LabelThemeEnum {
  Annotation = 'annotation',
  Classic = 'classic',
  StudioNext = 'studioNext',
  Context = 'context'
}
